function hash32(str) {
  let h = 2166136261 >>> 0;
  const s = String(str || '');
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h;
}

function clamp(v, lo, hi) {
  return Math.max(lo, Math.min(hi, v));
}

function countMatches(text, regex) {
  if (!text) return 0;
  const matches = String(text).match(regex);
  return matches ? matches.length : 0;
}

const BUMP_PATTERNS = {
  speed: /\b(quick|sharp|brisk|decisive|impulsive|fast|rapid|swift|snap|immediate)\w*/gi,
  depth: /\b(thought|reflect|analyt|deep|nuanc|layer|consider|explor|synthe)\w*/gi,
  creativity: /\b(creat|invent|imagin|origin|playful|quirky|whimsi|artistic|novel)\w*/gi,
  reliability: /\b(disciplin|methodic|steady|principle|integrit|precise|reliab|consist|diligen|rigorous)\w*/gi,
};

export function deriveStats(characterConfig, seedKey) {
  const config = characterConfig || {};
  const seed = String(seedKey || config.name || 'agent');
  const h = hash32(seed);

  // Baseline 45..55 per stat, each slot uses a different byte of the hash.
  const baseSpeed = 45 + (h % 11);
  const baseDepth = 45 + ((h >>> 8) % 11);
  const baseCreativity = 45 + ((h >>> 16) % 11);
  const baseReliability = 45 + ((h >>> 24) % 11);

  const corpus = [
    config.personality_prompt,
    config.backstory_prompt,
    config.quirks_and_mannerisms,
    config.beliefs_and_intents,
  ]
    .filter(Boolean)
    .join(' ');

  const verbosityDepthBump =
    config.verbosity === 'high' || config.verbosity === 'verbose'
      ? 15
      : config.verbosity === 'low' || config.verbosity === 'concise'
        ? -10
        : 0;

  return {
    speed: clamp(baseSpeed + countMatches(corpus, BUMP_PATTERNS.speed) * 5, 20, 95),
    depth: clamp(
      baseDepth + countMatches(corpus, BUMP_PATTERNS.depth) * 5 + verbosityDepthBump,
      20,
      95,
    ),
    creativity: clamp(
      baseCreativity + countMatches(corpus, BUMP_PATTERNS.creativity) * 5,
      20,
      95,
    ),
    reliability: clamp(
      baseReliability + countMatches(corpus, BUMP_PATTERNS.reliability) * 5,
      20,
      95,
    ),
  };
}
